import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { MrpProcessTemplateMachineLinkContainerModel } from '../../../../../../models/aggregates/mrp-prodsys'
import { ApiVisa } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class MrpProcessTemplateMachineLinkService extends BaseApiTemplateService<MrpProcessTemplateMachineLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-machine-link/backoffice-ep"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-machine-link/backoffice-ep"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + "mrp/mrp-process-template-machine-link/backoffice-ep"
    this.httpClient = http;
  }

}
